<div class="public-information">
	<property-detail-list
		[properties]="['problem', 'solution']"
		[columns]="true"
		[company]="company"
	>
	</property-detail-list>
	@if(showInvestmentSummary){
	<investment-summary
		[highestLevelOfFundingSecured]="company.highestLevelOfFundingSecured"
		[totalSecuredAndContingentAmount]="
			company.totalSecuredAndContingentAmount
		"
	>
	</investment-summary
	>} @if(includeInPublicView.deals) {
	<deals-table [showConfidentialStatus]="false" [deals]="company.deals">
	</deals-table>
	} @if(includeInPublicView.funding) {
	<funding-table
		[showConfidentialStatus]="isForCompanyContact"
		[funding]="company.funding"
	>
	</funding-table>
	} @if(company?.assets?.length > 0) {
	<div>
		<div class="title">
			{{ assetTitle }}
		</div>
		<asset-table
			[assets]="company?.assets"
			[initialColumns]="assetColumns"
			[embeddedScroll]="true"
		></asset-table>
	</div>
	} @if(featureSwitches.enableNews) {
	<news-component [company]="company"></news-component>
	}
</div>
